// @ts-nocheck
/* eslint-disable react-refresh/only-export-shared */
import LockIcon from "@/assets/icons/lock.svg?react";
import GroupIcon from "@/assets/icons/group.svg?react";
import GlobeIcon from "@/assets/icons/globe.svg?react";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer.js";

export const ENV = import.meta.env.VITE_ENV;

export const NEW_SURVEY = {
  id: null,
  title: "SIP 2026",
  startDate: "2026-03-01T00:00:00-05:00",
  hardDeadline: "2026-09-30T00:00:00-04:00",
};

// TODO Refactor this
export const PRME_ORGANIZATION_ID = ENV === "staging" ? 37 : 1;

export const UNPRME_FAQ_URL =
  "https://www.unprme.org/sip-2/?section=fa-qs#fa-qs";

export const DEFAULT_PAGE_SIZE = 10;

export const URL_REGEX =
  /^(https?:\/\/)?([\da-z\.-]+\.)+[a-z]{2,}(:\d+)?([\/\w\.-]*)*(\?[\w\.\-=&%]*)?$/i;

export const SAMPLE_SURVEY_PATH_PARAM_VALUE = "sample";

export const SUPPORTED_PICTURE_FILE_FORMATS = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/svg+xml",
];

export type EnumValue<T extends Record<string, any>> = T[keyof Omit<
  T,
  keyof typeof EnumFunctions
>] extends { value: infer V }
  ? V
  : never;

export const EnumFunctions = {
  getProperties() {
    const properties = Object.getOwnPropertyNames(this).filter(
      (i) => typeof this[i] !== "function",
    );
    return properties.reduce((acc, i) => {
      acc[this[i]?.value || this[i].label] = this[i].label;
      return acc;
    }, {});
  },
  asList() {
    const obj = this.getProperties();
    return Object.keys(obj).map((i) => ({
      label: obj[i],
      value: i,
    }));
  },
  getValues() {
    return Object.keys(this.getProperties()).map((i) => i);
  },
  getLabel(val) {
    return this.getProperties()[val];
  },
  getItemByValue(val) {
    const properties = Object.values(this).filter(
      (i) => typeof i !== "function",
    );
    return properties.find((i) => i.value === val);
  },
};

export const ROLES = {
  ADMIN: {
    value: "ADMIN",
    label: "PRME Agent",
    color: "#1E3250",
  },
  USER: {
    value: "USER",
    label: "User",
    color: "#1E3250",
  },
  ...EnumFunctions,
};

export type RolesValue = (typeof ROLES)[RolesKey]["value"];

export const Roles = {
  ...ROLES,
  ...EnumFunctions,
};

const ORGANIZATION_ROLES_DATA = {
  ADMIN: {
    value: "ADMIN",
    label: "Admin",
    color: "#1E3250",
    priority: 5,
  },
  SUPERVISOR: {
    value: "SUPERVISOR",
    label: "Supervisor",
    color: "#4e6483",
    priority: 4,
  },
  CONTRIBUTOR: {
    value: "CONTRIBUTOR",
    label: "Contributor",
    color: "#afc1d9",
    priority: 3,
  },
  MEMBER: {
    value: "MEMBER",
    label: "Member",
    color: "#afc1d9",
    priority: 2,
  },
  GUEST: {
    value: "GUEST",
    label: "Non-Signatory Contributor",
    color: "#afc1d9",
    priority: 1,
  },
} as const;

export type OrganizationRoleValue =
  (typeof ORGANIZATION_ROLES_DATA)[OrganizationRoleKey]["value"];

export const OrganizationRoles = {
  ...ORGANIZATION_ROLES_DATA,
  ...EnumFunctions,
};

export const SurveyStatus = {
  ACTIVE: {
    value: "ACTIVE",
    label: "Active",
    background: "rgba(2, 186, 60, 0.087)",
    color: "rgba(0, 107, 59, 0.906)",
  },
  ENDED: {
    value: "ENDED",
    label: "Ended",
    background: "rgba(255, 1, 1, 0.063)",
    color: "rgba(187, 0, 7, 0.836)",
  },
  ...EnumFunctions,
};

export const SurveyType = {
  LEGACY_SIP: {
    value: "LEGACY_SIP",
    label: "Legacy SIP",
  },
  SIP: {
    value: "SIP",
    label: "SIP",
  },
  ...EnumFunctions,
};

export const SurveyActions = {
  SUBMIT: {
    value: "SUBMIT",
    label: "Submit",
  },
  EDIT: {
    value: "EDIT",
    label: "Edit",
  },
  ...EnumFunctions,
};

export const SurveyAudience = {
  ORGANIZATION: {
    value: "ORGANIZATION",
    label: "Organization",
  },
  USER: {
    value: "USER",
    label: "User",
  },
};

export const OptionType = {
  SINGLE_CHOICE: {
    label: "Single choice",
    value: "SINGLE_CHOICE",
  },
  MULTIPLE_CHOICE: {
    label: "Multiple choice",
    value: "MULTIPLE_CHOICE",
  },
  CHOICE_TEXT: {
    label: "Text choice",
    value: "CHOICE_TEXT",
  },
  TEXT: {
    label: "Text",
    value: "TEXT",
  },
  NUMBER: {
    label: "Number",
    value: "NUMBER",
  },
  PROMPT: {
    label: "Prompt",
    value: "PROMPT",
  },
  ...EnumFunctions,
};

export interface SharingRight {
  label: string;
  value: string;
  className?: string;
  color: string;
}

export const SharingRights = {
  PRIVATE: {
    value: "PRIVATE",
    label: "Private",
    className: "private",
    color: "#7A9E54",
    icon: <BaseSvgRenderer component={LockIcon} />,
  },
  PRME_COMMUNITY: {
    value: "PRME_COMMUNITY",
    label: "PRME Community",
    className: "prme-community",
    color: "#5B92E5",
    icon: <BaseSvgRenderer component={GroupIcon} />,
  },
  PUBLIC: {
    value: "PUBLIC",
    label: "Public",
    className: "public",
    color: "#ED901D",
    icon: <BaseSvgRenderer component={GlobeIcon} />,
  },
  ...EnumFunctions,
};

export const RegistrationStatus = {
  PENDING: {
    value: "PENDING",
    label: "Pending",
    backgroundColor: "rgba(1, 68, 255, 0.059)",
    color: "rgba(0, 37, 158, 0.797)",
  },
  REGISTERED: {
    value: "REGISTERED",
    label: "Registered",
    backgroundColor: "rgba(2, 186, 60, 0.087)",
    color: "rgba(0, 107, 59, 0.906)",
  },
  ...EnumFunctions,
};

export const Chapters = {
  AFRICA: {
    value: "AFRICA",
    label: "Africa",
  },
  ASEAN: {
    value: "ASEAN+",
    label: "ASEAN+",
  },
  AUSTRALIA_NEW_ZEALAND: {
    value: "AUSTRALIA_NEW_ZEALAND",
    label: "Australia & New Zealand",
  },
  BRAZIL: {
    value: "BRAZIL",
    label: "Brazil",
  },
  CEE: {
    value: "CEE",
    label: "CEE",
  },
  DACH: {
    value: "DACH",
    label: "DACH",
  },
  EURASIA: {
    value: "EURASIA",
    label: "Eurasia",
  },
  FRANCE_BENELUX: {
    value: "FRANCE_BENELUX",
    label: "France & Benelux",
  },
  IBERIA: {
    value: "IBERIA",
    label: "Iberia",
  },
  INDIA: {
    value: "INDIA",
    label: "India",
  },
  ITALY: {
    value: "ITALY",
    label: "Italy",
  },
  LAC: {
    value: "LAC",
    label: "LAC",
  },
  MIDDLE_EAST: {
    value: "MIDDLE_EAST",
    label: "Middle East",
  },
  NORDIC: {
    value: "NORDIC",
    label: "Nordic",
  },
  NORTH_AMERICA: {
    value: "NORTH_AMERICA",
    label: "North America",
  },
  POLAND: {
    value: "POLAND",
    label: "Poland",
  },
  UK_IRELAND: {
    value: "UK_IRELAND",
    label: "UK & Ireland",
  },
  ...EnumFunctions,
};

export const OrganizationCommunicationStatuses = {
  COMMUNICATING: {
    value: "COMMUNICATING",
    label: "Communicating",
    backgroundColor: "rgba(162, 195, 245, 1)",
    color: "rgba(63, 95, 146, 1)",
  },
  NON_COMMUNICATING: {
    value: "NON_COMMUNICATING",
    label: "Non-Communicating",
    backgroundColor: "rgba(255, 191, 1, 0.19)",
    color: "rgba(120, 50, 0, 0.81)",
  },
  PENDING_DELISTING: {
    value: "PENDING_DELISTING",
    label: "Pending Delisting",
    backgroundColor: "rgba(255, 191, 1, 0.19)",
    color: "rgba(120, 50, 0, 0.81)",
  },
  DELISTED: {
    value: "DELISTED",
    label: "Delisted",
    backgroundColor: "rgba(255, 1, 1, 0.06)",
    color: "rgba(187, 0, 7, 0.84)",
  },
  ...EnumFunctions,
};

export const SipPreviews = {
  EN: {
    label: "English",
    value: "EN",
    link: "https://commons-static.s3.eu-central-1.amazonaws.com/assets/previews/2026+SIP+Preview_EN.xlsx",
  },
  FR: {
    label: "French",
    value: "FR",
    link: "https://commons-static.s3.eu-central-1.amazonaws.com/assets/previews/2026+SIP+Preview_FR.xlsx",
  },
  ES: {
    label: "Spanish",
    value: "ES",
    link: "https://commons-static.s3.eu-central-1.amazonaws.com/assets/previews/2026+SIP+Preview_ES.xlsx",
  },
  PT: {
    label: "Portuguese",
    value: "PT",
    link: "https://commons-static.s3.eu-central-1.amazonaws.com/assets/previews/2026+SIP+Preview_PT.xlsx",
  },
  ...EnumFunctions,
};

const NOTIFICATION_TYPE_VALUES = {
  MENTION: "MENTION",
  POST_COMMENT_CREATE: "POST_COMMENT_CREATE",
  COMMENT_REPLY_CREATE: "COMMENT_REPLY_CREATE",
  POST_LIKE: "POST_LIKE",
  FEATURED_CONTENT: "FEATURED_CONTENT",
};

export const NotificationTypeCategories = {
  COMMUNITY: {
    category: "COMMUNITY",
    labelKey: "community.labels.community",
  },
};

export const NotificationTypes = {
  MENTION: {
    value: NOTIFICATION_TYPE_VALUES.MENTION,
    labelKey: "community.labels.mention",
    category: NotificationTypeCategories.COMMUNITY.category,
  },
  POST_COMMENT_CREATE: {
    value: NOTIFICATION_TYPE_VALUES.POST_COMMENT_CREATE,
    labelKey: "community.labels.postCommentCreate",
    category: NotificationTypeCategories.COMMUNITY.category,
  },
  COMMENT_REPLY_CREATE: {
    value: NOTIFICATION_TYPE_VALUES.COMMENT_REPLY_CREATE,
    labelKey: "community.labels.commentReplyCreate",
    category: NotificationTypeCategories.COMMUNITY.category,
  },
  POST_LIKE: {
    value: NOTIFICATION_TYPE_VALUES.POST_LIKE,
    labelKey: "community.labels.postLike",
    category: NotificationTypeCategories.COMMUNITY.category,
  },
  FEATURED_CONTENT: {
    value: NOTIFICATION_TYPE_VALUES.FEATURED_CONTENT,
    labelKey: "community.labels.featuredContent",
    category: NotificationTypeCategories.COMMUNITY.category,
  },
  ...EnumFunctions,
};

const EMAIL_TYPE_VALUES = {
  SURVEY_SUBMISSION: "SURVEY_SUBMISSION",
  SURVEY_ASSIGNMENT: "SURVEY_ASSIGNMENT",
  SURVEY_REMINDER: "SURVEY_REMINDER",
  SURVEY_VIEW_EVIDENCE_USAGE: "SURVEY_VIEW_EVIDENCE_USAGE",
  DISCUSSION_REPORT: "DISCUSSION_REPORT",
  COMMENT_REPORT: "COMMENT_REPORT",
  DIGEST: "DIGEST",
  EVIDENCE_REQUEST_CREATED: "EVIDENCE_REQUEST_CREATED",
  EVIDENCE_REQUEST_SUBMITTED: "EVIDENCE_REQUEST_SUBMITTED",
  EVIDENCE_REQUEST_REMINDER: "EVIDENCE_REQUEST_REMINDER",
  EVIDENCE_EDIT_REQUEST: "EVIDENCE_EDIT_REQUEST",
};

export const EmailTypeCategories = {
  SURVEY: {
    category: "SURVEY",
    labelKey: "emails.survey",
  },
  EVIDENCE: {
    category: "EVIDENCE",
    labelKey: "emails.evidence",
  },
  COMMUNITY: {
    category: "COMMUNITY",
    labelKey: "emails.community",
  },
};

export const EmailTypes = {
  SURVEY_SUBMISSION: {
    value: EMAIL_TYPE_VALUES.SURVEY_SUBMISSION,
    labelKey: "emails.types.surveySubmission",
    category: EmailTypeCategories.SURVEY.category,
  },
  SURVEY_ASSIGNMENT: {
    value: EMAIL_TYPE_VALUES.SURVEY_ASSIGNMENT,
    labelKey: "emails.types.surveyAssignment",
    category: EmailTypeCategories.SURVEY.category,
  },
  SURVEY_REMINDER: {
    value: EMAIL_TYPE_VALUES.SURVEY_REMINDER,
    labelKey: "emails.types.surveyReminder",
    category: EmailTypeCategories.SURVEY.category,
  },
  SURVEY_VIEW_EVIDENCE_USAGE: {
    value: EMAIL_TYPE_VALUES.SURVEY_VIEW_EVIDENCE_USAGE,
    labelKey: "emails.types.surveyViewEvidenceUsage",
    category: EmailTypeCategories.SURVEY.category,
  },
  DISCUSSION_REPORT: {
    value: EMAIL_TYPE_VALUES.DISCUSSION_REPORT,
    labelKey: "emails.types.discussionReport",
    category: EmailTypeCategories.COMMUNITY.category,
  },
  COMMENT_REPORT: {
    value: EMAIL_TYPE_VALUES.COMMENT_REPORT,
    labelKey: "emails.types.commentReport",
    category: EmailTypeCategories.COMMUNITY.category,
  },
  DIGEST: {
    value: EMAIL_TYPE_VALUES.DIGEST,
    labelKey: "emails.types.digest",
    category: EmailTypeCategories.COMMUNITY.category,
  },
  EVIDENCE_REQUEST_CREATED: {
    value: EMAIL_TYPE_VALUES.EVIDENCE_REQUEST_CREATED,
    labelKey: "emails.types.evidenceRequestCreated",
    category: EmailTypeCategories.EVIDENCE.category,
  },
  EVIDENCE_REQUEST_SUBMITTED: {
    value: EMAIL_TYPE_VALUES.EVIDENCE_REQUEST_SUBMITTED,
    labelKey: "emails.types.evidenceRequestSubmitted",
    category: EmailTypeCategories.EVIDENCE.category,
  },
  EVIDENCE_REQUEST_REMINDER: {
    value: EMAIL_TYPE_VALUES.EVIDENCE_REQUEST_REMINDER,
    labelKey: "emails.types.evidenceRequestReminder",
    category: EmailTypeCategories.EVIDENCE.category,
  },
  EVIDENCE_EDIT_REQUEST: {
    value: EMAIL_TYPE_VALUES.EVIDENCE_EDIT_REQUEST,
    labelKey: "emails.types.evidenceEditRequest",
    category: EmailTypeCategories.EVIDENCE.category,
  },
  ...EnumFunctions,
};

export const Frequency = {
  DAILY: {
    value: "DAILY",
    label: "Daily",
  },
  WEEKLY: {
    value: "WEEKLY",
    label: "Weekly",
  },
  BIWEEKLY: {
    value: "BIWEEKLY",
    label: "Bi-weekly",
  },
  MONTHLY: {
    value: "MONTHLY",
    label: "Monthly",
  },
  ...EnumFunctions,
};

export const EntitiesCondition = {
  AND: {
    value: "AND",
    label: "And",
  },
  OR: {
    value: "OR",
    label: "Or",
  },
};

export const HONORIFICS_DATA = {
  MISS: {
    value: "MISS",
    label: "Miss",
  },
  MS: {
    value: "MS",
    label: "Ms.",
  },
  MRS: {
    value: "MRS",
    label: "Mrs.",
  },
  MR: {
    value: "MR",
    label: "Mr.",
  },
  DR: {
    value: "DR",
    label: "Dr.",
  },
  PROF: {
    value: "PROF",
    label: "Prof.",
  },
  PROF_DR: {
    value: "PROF_DR",
    label: "Prof. Dr.",
  },
  REV: {
    value: "REV",
    label: "Rev.",
  },
  HON: {
    value: "HON",
    label: "Hon.",
  },
  BROTHER: {
    value: "BROTHER",
    label: "Brother",
  },
  SISTER: {
    value: "SISTER",
    label: "Sister",
  },
  CAPT: {
    value: "CAPT",
    label: "Capt.",
  },
  COL: {
    value: "COL",
    label: "Col.",
  },
  LT: {
    value: "LT",
    label: "Lt.",
  },
  ENG: {
    value: "ENG",
    label: "Eng.",
  },
  ESQ: {
    value: "ESQ",
    label: "Esq.",
  },
  FR: {
    value: "FR",
    label: "Fr.",
  },
} as const;

export type HonorificsValue = (typeof HONORIFICS_DATA)[HonorificsKey]["value"];

export const Honorifics = {
  ...HONORIFICS_DATA,
  ...EnumFunctions,
};

export const SurveyViewDataFormat = {
  RAW: {
    value: "RAW",
    label: "Q&A Format",
  },
  DESCRIPTIVE: {
    value: "DESCRIPTIVE",
    label: "Integrated Response",
  },
  ...EnumFunctions,
};

export const SurveyViewDistributionFormat = {
  DIGITAL: {
    value: "DIGITAL",
    label: "Online sharing",
  },
  PRINT: {
    value: "PRINT",
    label: "Printing",
  },
  ...EnumFunctions,
};
